/* Explore our Collection: swipe / scroll carousel where the card in the middle is in focus and the side cards tilt away.
   Without JavaScript it is a plain swipe row. Vanilla JS, no dependencies. */
(function () {
  'use strict';
  function init(root) {
    if (root.__bnlFlow) return;
    root.__bnlFlow = true;
    var track = root.querySelector('[data-xflow-track]');
    var items = Array.prototype.slice.call(root.querySelectorAll('[data-xflow-item]'));
    if (!track || !items.length) return;
    var ticking = false;

    function center(item) { return item.offsetLeft + item.offsetWidth / 2; }
    function nearest() {
      var mid = track.scrollLeft + track.clientWidth / 2, best = 0, gap = Infinity;
      items.forEach(function (it, i) { var d = Math.abs(center(it) - mid); if (d < gap) { gap = d; best = i; } });
      return best;
    }
    function update() {
      ticking = false;
      var mid = track.scrollLeft + track.clientWidth / 2;
      var active = nearest();
      items.forEach(function (it, i) {
        var d = (center(it) - mid) / (it.offsetWidth * 1.05);
        var a = Math.min(Math.abs(d), 2);
        it.style.setProperty('--ry', (Math.max(-1.4, Math.min(1.4, d)) * 34).toFixed(1) + 'deg');
        it.style.setProperty('--sc', (1.06 - Math.min(a, 1.5) * 0.15).toFixed(3));
        it.style.setProperty('--op', (1 - Math.min(a, 2) * 0.2).toFixed(2));
        it.classList.toggle('is-active', i === active);
      });
    }
    function go(i) {
      i = Math.max(0, Math.min(items.length - 1, i));
      var calm = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      track.scrollTo({ left: center(items[i]) - track.clientWidth / 2, behavior: calm ? 'auto' : 'smooth' });
    }
    track.addEventListener('scroll', function () { if (!ticking) { ticking = true; window.requestAnimationFrame(update); } }, { passive: true });
    window.addEventListener('resize', update);
    /* tapping a side card brings it to the middle first; tapping the middle card opens it */
    items.forEach(function (it, i) {
      it.addEventListener('click', function (e) { if (i !== nearest()) { e.preventDefault(); go(i); } });
    });
    var prev = root.querySelector('[data-xflow-prev]'), next = root.querySelector('[data-xflow-next]');
    if (prev) prev.addEventListener('click', function () { go(nearest() - 1); });
    if (next) next.addEventListener('click', function () { go(nearest() + 1); });
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); go(nearest() + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(nearest() - 1); }
    });
    track.scrollLeft = center(items[Math.floor((items.length - 1) / 2)]) - track.clientWidth / 2;
    update();
  }
  function all() { Array.prototype.forEach.call(document.querySelectorAll('[data-xflow]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all); else all();
  document.addEventListener('shopify:section:load', all);
})();
